import React, { useEffect, useState } from "react";
import { Conversation } from "../utils/Types.ts";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "../utils/AuthContext.tsx";
import { useConversations } from "@/utils/Api.ts";

interface ConversationDropdownProps {
  onSelectionChange: (selectedConversation?: Conversation) => void;
  defaultValue?: string;
}

const ConversationDropdown: React.FC<ConversationDropdownProps> = ({ onSelectionChange, defaultValue }) => {
  const { token, currentAccount } = useAuth();
  const {
    data: conversations,
    isLoading,
    isError,
  } = useConversations(currentAccount?.id!, "*", "chat", token ?? undefined);
  const [value, setValue] = useState<string | undefined>(defaultValue);

  const handleSelectChange = (value: string) => {
    if (value) {
      // Pass selection to parent component
      onSelectionChange(conversations?.find((c) => c.id == value));
    } else {
      onSelectionChange(undefined);
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div>
      {isLoading ? (
        <p>Loading conversations...</p>
      ) : isError ? (
        <p style={{ color: "red" }}>{isError}</p>
      ) : (
        <Select onValueChange={handleSelectChange} value={value}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Select A Conversation" />
          </SelectTrigger>
          <SelectContent>
            {conversations?.map((c) => (
              <SelectItem key={c.id} value={c.id}>
                {c.name ?? c.id}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};

export default ConversationDropdown;
